var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2033 28.5731C22.0274 28.5731 28.37 22.2305 28.37 14.4064C28.37 6.58239 22.0274 0.239746 14.2033 0.239746C6.37927 0.239746 0.0366211 6.58239 0.0366211 14.4064C0.0366211 22.2305 6.37927 28.5731 14.2033 28.5731Z",
    fill: "#6D89AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5017 7.524C10.5017 8.4059 9.8302 9.1197 8.7801 9.1197C7.7708 9.1197 7.0993 8.4059 7.1201 7.524C7.0993 6.5992 7.7708 5.90625 8.8002 5.90625C9.8302 5.90625 10.4816 6.5992 10.5017 7.524ZM7.2045 20.6531V10.3802H10.3972V20.6524H7.2045V20.6531Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.956 13.6585C12.956 12.3772 12.9138 11.2848 12.8716 10.3814H15.6447L15.7921 11.7888H15.8551C16.2753 11.1374 17.3255 10.1509 19.027 10.1509C21.1273 10.1509 22.7028 11.5374 22.7028 14.5612V20.6543H19.5102V14.9613C19.5102 13.6371 19.0484 12.7343 17.8931 12.7343C17.0105 12.7343 16.4857 13.3435 16.276 13.9313C16.1915 14.1417 16.15 14.4352 16.15 14.7301V20.6543H12.9573V13.6585H12.956Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLinkedin);
export default __webpack_public_path__ + "static/media/ico-linkedin.abe2c9b2015e175175fcc5cb2d67b7f1.svg";
export { ForwardRef as ReactComponent };